import React, { createContext, type FC, useContext } from "react";

import type { TranslationsNamespaceProviderProps } from "./types";

export const TranslationsNamespaceContext = createContext<string>("");

const TranslationsNamespaceProvider: FC<TranslationsNamespaceProviderProps> = ({
  namespace,
  children,
}) => {
  return (
    <TranslationsNamespaceContext.Provider value={namespace}>
      {children}
    </TranslationsNamespaceContext.Provider>
  );
};

export const useTranslationsNamespace = () =>
  useContext(TranslationsNamespaceContext);

export default TranslationsNamespaceProvider;
